import { render } from "./projectext4.vue?vue&type=template&id=5e811f7f&scoped=true"
import script from "./projectext4.vue?vue&type=script&lang=js"
export * from "./projectext4.vue?vue&type=script&lang=js"

import "./projectext4.vue?vue&type=style&index=0&id=5e811f7f&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e811f7f"]])

export default __exports__